import React, { useState } from "react";
import { ColourPallette } from './ColourPallette.js';
import { AnnotationsColorPalette } from './ColourPallette.js';


const HighlightPopup = (props) => {

    const [showDelete, setShowDelete] = useState(true);

    var comment = props.comment;
    var id = props.id;

    //console.log("HighlightPopup", props);





    if (props.type == "_custom_") {
        return (
            <div style={{ width: "300px", borderRadius: "5px", padding: "10px", backgroundColor: "#fdfdfd", border: "2px solid #ccc", borderLeft: `2px solid ${AnnotationsColorPalette["dark_" + comment.colour]}`, }}>
                <div style={{display: "flex", flexDirection: "row"}}>
                    <div style={{flex: 1 }}>Author: {comment.author}</div>

                    {comment.deletable && showDelete && (
                        <div style={{ width: "25px", textAlign: "right" }}>
                            <i className="fas fa-trash-alt" title="Delete this annotation" style={{ cursor: "pointer" }} onClick={() => { setShowDelete(false); props.delete(); }}></i>
                        </div>
                    )}
                </div>
                <div style={{color: "#888", fontSize: "0.7rem"}}>{comment.created}</div>
                <div style={{ marginTop: "15px", marginBottom: "5px" }}>
                    <div className="thin-scrollbar" style={{ maxHeight: "100px", overflowY: "auto" }}>
                        {comment.text}
                    </div>
                </div>
            </div>
        );
    } else if (comment.type == "_summary_") {

        //console.log(comment);

        return (<div className="Highlight__popup" style={{ backgroundColour: ColourPallette[comment.type] }}>
            <h5 style={{ margin: "0px" }}>Summary extracted claim</h5>
        </div>);
    } else if (comment.type == "_comparison_deleted_" || comment.type == "_comparison_inserted_" || comment.type == "_comparison_inserted_special_" || comment.type == "_comparison_deleted_special_") {

        return (<div className="Highlight__popup" style={{ backgroundColour: ColourPallette[comment.type] }}>
            <span>{comment.value.trim()}</span>
        </div>);

    } else {
        return (<div className="Highlight__popup" style={{ backgroundColour: ColourPallette[comment.type] }}>
            <h5 style={{ margin: "0px" }}>{comment.type}</h5>
            <h6>"{comment.value.trim()}"</h6>
        </div>);
    }
}



export default HighlightPopup;